/**
 * DEV-1786 (эпик DEV-1781). i18n раздела «Лендинги» в «Администрировании».
 * Overlay-модуль: подмешивается deepMerge поверх базовых локалей.
 */
export const landingsMessages = {
  ru: {
    common: {
      navigation: {
        adminLandings: 'Лендинги',
      },
    },
    landings: {
      title: 'Лендинги',
      subtitle: 'Публикация площадок и настройки их видимости в поиске',
      search: 'Поиск по названию или адресу',
      filters: {
        kind: 'Тип',
        status: 'Статус',
        all: 'Все',
      },
      kind: {
        native: 'Нативный',
        anonymous: 'Обезличенный',
      },
      status: {
        DRAFT: 'Черновик',
        PUBLISHED: 'Опубликован',
        UNPUBLISHED: 'Снят с публикации',
      },
      deploy: {
        PENDING: 'В очереди',
        RUNNING: 'Публикуется…',
        PUBLISHED: 'Выкачен',
        FAILED: 'Ошибка выкатки',
        UNKNOWN: 'Нет данных',
        pipeline: 'Пайплайн',
      },
      indexing: {
        open: 'В поиске',
        closed: 'Закрыт',
        unset: 'Не задано',
        hint: 'Открыт ли лендинг поисковым системам',
      },
      columns: {
        landing: 'Лендинг',
        kind: 'Тип',
        status: 'Статус',
        indexing: 'Индексация',
        traffic: 'Просмотры · заявки',
        updated: 'Обновлён',
      },
      trafficPeriod: 'за 7 дней',
      trafficUnavailable: 'Статистика недоступна',
      empty: {
        title: 'Лендингов нет',
        description: 'Каталог площадок пуст или отфильтрован полностью.',
      },
      card: {
        tabs: {
          overview: 'Обзор',
          seo: 'SEO',
        },
        address: 'Адрес и доступ',
        addressHint: 'Рабочий адрес лендинга. Поддомены для лендингов не используются.',
        openPage: 'Открыть страницу',
        form: 'Форма заявки',
        formConnected: 'Подключена · отправка на тот же домен',
        publication: 'Публикация',
        lastDeploy: 'Последняя выкатка',
        publishedBy: 'Запускал',
        never: 'Ещё не публиковался',
        preview: 'Превью',
        previewHint: 'Страница открывается в новой вкладке',
        traffic: 'За 7 дней',
        views: 'Просмотры',
        leads: 'Заявки',
        notFound: 'Лендинг не найден',
      },
      anonymous: {
        title: 'Обезличенный контур',
        description:
          'Площадка живёт на домене партнёра и собирается отдельным пайплайном (ADR-0022). Публикация и настройки SEO для неё недоступны — они задаются в её собственном контуре.',
      },
      actions: {
        publish: 'Опубликовать',
        unpublish: 'Снять с публикации',
        open: 'Открыть',
      },
      seo: {
        indexing: {
          title: 'Индексация',
          toggle: 'Открыть для поисковых систем',
          on: 'Включено: страница открыта поиску — meta robots = index, follow. Лендинг живёт на основном домене, своего robots.txt у него нет: общий файл домена мы не трогаем.',
          off: 'Выключено: страница остаётся доступной, но из выдачи её убирает meta robots = noindex, nofollow. Лендинг живёт на основном домене, своего robots.txt у него нет: общий файл домена мы не трогаем.',
          sitemap: 'Добавить в sitemap.xml основного сайта',
          sitemapHint:
            'Доступно только для открытых лендингов: закрытый в карте сайта — противоречие, за которое Search Console ругается.',
        },
        meta: {
          title: 'Мета-теги',
          seoTitle: 'Заголовок страницы (title)',
          seoDescription: 'Описание (description)',
          titleCounter: '{count} из 60 символов — влезет в выдачу целиком',
          titleCounterOver: '{count} символов — в выдаче обрежется примерно на 60',
          descriptionCounter: '{count} из 160 символов — поисковик покажет около 160',
          canonical: 'Канонический адрес',
          canonicalSelf: 'Свой адрес — {url}',
          canonicalExternal: 'Другая страница — указать адрес',
          canonicalUrl: 'Адрес канонической страницы',
          canonicalUrlError: 'Нужен полный адрес со схемой: https://…',
          canonicalHint:
            'Если тот же проект есть на основном сайте, канонической делают одну страницу — иначе они делят между собой один и тот же запрос.',
          image: 'Картинка для мессенджеров и соцсетей',
          imageHint: '1200 × 630, JPG или PNG — её показывают Telegram, WhatsApp и Facebook',
          imageUpload: 'Загрузить',
          imageReplace: 'Заменить',
          imageError: 'Картинку загрузить не удалось',
        },
        output: {
          title: 'Что уедет на прод',
          sitemapFile: 'sitemap.xml основного сайта',
          sitemapIn: 'адрес включён',
          sitemapOut: 'адрес не включён — лендинг закрыт от индексации',
          hint: 'Теги подставляются при публикации из настроек выше — руками в разметке лендинга их не правят, иначе настройка и прод разъедутся.',
        },
        preview: {
          title: 'Как это увидят в поиске',
          fallbackTitle: 'Заголовок из вёрстки лендинга',
          fallbackDescription: 'Описание из вёрстки лендинга',
          hint: 'Поисковик вправе показать свой текст, но берёт он его из этих полей.',
        },
        checks: {
          title: 'Проверки',
          titleOk: 'Заголовок {count} символов — в выдаче поместится целиком',
          titleLong: 'Заголовок {count} символов — в выдаче обрежется',
          titleEmpty: 'Заголовок не задан — на прод уедет тот, что в вёрстке',
          descriptionOk: 'Описание {count} символов',
          descriptionLong: 'Описание {count} символов — поисковик покажет около 160',
          descriptionEmpty: 'Описание не задано — на прод уедет то, что в вёрстке',
          complexCompeting:
            'Тот же проект открыт на основном сайте: {url}. Выберите, какая из двух страниц каноническая',
          complexAction: 'Сделать канонической страницу проекта',
          canonicalInvalid: 'Канонический адрес неполный: нужен адрес со схемой https://',
          closed:
            'Лендинг закрыт от индексации — настройки сохранятся, но в поиск страница не попадёт',
        },
        footer: 'Настройки применяются при следующей публикации.',
        save: 'Сохранить',
        cancel: 'Отменить',
      },
      publishModal: {
        publishTitle: 'Опубликовать лендинг',
        unpublishTitle: 'Снять с публикации',
        publishConfirm: 'Опубликовать',
        unpublishConfirm: 'Снять',
        cancel: 'Отмена',
        willDeploy: 'Что уедет на прод',
        robots: 'Мета robots',
        canonical: 'Канонический адрес',
        sitemap: 'Карта сайта',
        sitemapIn: 'адрес войдёт в общий sitemap.xml',
        sitemapOut: 'адрес не включён — лендинг закрыт от индексации',
        robotsFileNote:
          'robots.txt общий для домена и здесь не меняется: индексацию закрывает мета-тег.',
        closedWarning:
          'Лендинг закрыт от индексации: страница будет доступна по адресу, но из поиска её уберёт мета-тег.',
        seoEmptyWarning:
          'Заголовок и описание не заданы — на прод уедет то, что написано в вёрстке.',
        unpublishWarning: 'Файлы будут удалены из хранилища, адрес начнёт отдавать 404.',
      },
    },
  },
  en: {
    common: {
      navigation: {
        adminLandings: 'Landings',
      },
    },
    landings: {
      title: 'Landings',
      subtitle: 'Publishing landing pages and their search visibility',
      search: 'Search by name or address',
      filters: {
        kind: 'Type',
        status: 'Status',
        all: 'All',
      },
      kind: {
        native: 'Native',
        anonymous: 'Anonymised',
      },
      status: {
        DRAFT: 'Draft',
        PUBLISHED: 'Published',
        UNPUBLISHED: 'Unpublished',
      },
      deploy: {
        PENDING: 'Queued',
        RUNNING: 'Publishing…',
        PUBLISHED: 'Deployed',
        FAILED: 'Deploy failed',
        UNKNOWN: 'No data',
        pipeline: 'Pipeline',
      },
      indexing: {
        open: 'Indexed',
        closed: 'Closed',
        unset: 'Not set',
        hint: 'Whether the landing is open to search engines',
      },
      columns: {
        landing: 'Landing',
        kind: 'Type',
        status: 'Status',
        indexing: 'Indexing',
        traffic: 'Views · leads',
        updated: 'Updated',
      },
      trafficPeriod: 'last 7 days',
      trafficUnavailable: 'Statistics unavailable',
      empty: {
        title: 'No landings',
        description: 'The catalogue is empty or fully filtered out.',
      },
      card: {
        tabs: {
          overview: 'Overview',
          seo: 'SEO',
        },
        address: 'Address and access',
        addressHint: 'Working address of the landing. Subdomains are not used for landings.',
        openPage: 'Open page',
        form: 'Lead form',
        formConnected: 'Connected · posts to the same origin',
        publication: 'Publication',
        lastDeploy: 'Last deploy',
        publishedBy: 'Triggered by',
        never: 'Never published',
        preview: 'Preview',
        previewHint: 'Opens in a new tab',
        traffic: 'Last 7 days',
        views: 'Views',
        leads: 'Leads',
        notFound: 'Landing not found',
      },
      anonymous: {
        title: 'Anonymised contour',
        description:
          'The page lives on a partner domain and is built by its own pipeline (ADR-0022). Publishing and SEO settings are managed in that contour.',
      },
      actions: {
        publish: 'Publish',
        unpublish: 'Unpublish',
        open: 'Open',
      },
      seo: {
        indexing: {
          title: 'Indexing',
          toggle: 'Open to search engines',
          on: 'On: the page is open to search — meta robots = index, follow. The landing lives on the main domain and has no robots.txt of its own: the shared file is left alone.',
          off: 'Off: the page stays reachable, but meta robots = noindex, nofollow keeps it out of search. The landing lives on the main domain and has no robots.txt of its own: the shared file is left alone.',
          sitemap: 'Add to the main site sitemap.xml',
          sitemapHint:
            'Available for open landings only: a closed page in the sitemap is a contradiction Search Console complains about.',
        },
        meta: {
          title: 'Meta tags',
          seoTitle: 'Page title',
          seoDescription: 'Description',
          titleCounter: '{count} of 60 characters — fits the search result in full',
          titleCounterOver: '{count} characters — search will cut it around 60',
          descriptionCounter: '{count} of 160 characters — search shows about 160',
          canonical: 'Canonical URL',
          canonicalSelf: 'Own address — {url}',
          canonicalExternal: 'Another page — set the address',
          canonicalUrl: 'Canonical page address',
          canonicalUrlError: 'A full address is required: https://…',
          canonicalHint:
            'If the same project exists on the main site, exactly one page should be canonical — otherwise they split the same query between them.',
          image: 'Image for messengers and social networks',
          imageHint: '1200 × 630, JPG or PNG — shown by Telegram, WhatsApp and Facebook',
          imageUpload: 'Upload',
          imageReplace: 'Replace',
          imageError: 'The image could not be uploaded',
        },
        output: {
          title: 'What goes to production',
          sitemapFile: 'main site sitemap.xml',
          sitemapIn: 'the URL is included',
          sitemapOut: 'the URL is excluded — the landing is closed to indexing',
          hint: 'Tags are applied on publish from the settings above — they are not edited by hand in the landing markup, or the settings and production drift apart.',
        },
        preview: {
          title: 'How search will show it',
          fallbackTitle: 'Title from the landing markup',
          fallbackDescription: 'Description from the landing markup',
          hint: 'Search may show its own text, but it takes it from these fields.',
        },
        checks: {
          title: 'Checks',
          titleOk: 'Title is {count} characters — fits the search result in full',
          titleLong: 'Title is {count} characters — search will cut it',
          titleEmpty: 'Title is not set — the markup value goes to production',
          descriptionOk: 'Description is {count} characters',
          descriptionLong: 'Description is {count} characters — search shows about 160',
          descriptionEmpty: 'Description is not set — the markup value goes to production',
          complexCompeting:
            'The same project is open on the main site: {url}. Choose which of the two pages is canonical',
          complexAction: 'Make the project page canonical',
          canonicalInvalid: 'The canonical address is incomplete: use a full https:// address',
          closed:
            'The landing is closed to indexing — settings will be saved, but the page will not reach search',
        },
        footer: 'Settings are applied on the next publish.',
        save: 'Save',
        cancel: 'Cancel',
      },
      publishModal: {
        publishTitle: 'Publish landing',
        unpublishTitle: 'Unpublish landing',
        publishConfirm: 'Publish',
        unpublishConfirm: 'Unpublish',
        cancel: 'Cancel',
        willDeploy: 'What goes to production',
        robots: 'Robots meta',
        canonical: 'Canonical URL',
        sitemap: 'Sitemap',
        sitemapIn: 'the URL will be added to the shared sitemap.xml',
        sitemapOut: 'the URL is excluded — the landing is closed to indexing',
        robotsFileNote:
          'robots.txt is shared across the domain and is not changed here: indexing is controlled by the meta tag.',
        closedWarning:
          'The landing is closed to indexing: the page stays reachable, but the meta tag keeps it out of search.',
        seoEmptyWarning:
          'Title and description are not set — the markup values will go to production as they are.',
        unpublishWarning:
          'Files will be removed from storage and the URL will start returning 404.',
      },
    },
  },
  vn: {
    common: {
      navigation: {
        adminLandings: 'Trang đích',
      },
    },
    landings: {
      title: 'Trang đích',
      subtitle: 'Xuất bản trang đích và khả năng hiển thị trên tìm kiếm',
      search: 'Tìm theo tên hoặc địa chỉ',
      filters: {
        kind: 'Loại',
        status: 'Trạng thái',
        all: 'Tất cả',
      },
      kind: {
        native: 'Thương hiệu riêng',
        anonymous: 'Ẩn danh',
      },
      status: {
        DRAFT: 'Bản nháp',
        PUBLISHED: 'Đã xuất bản',
        UNPUBLISHED: 'Đã gỡ',
      },
      deploy: {
        PENDING: 'Đang chờ',
        RUNNING: 'Đang xuất bản…',
        PUBLISHED: 'Đã triển khai',
        FAILED: 'Triển khai lỗi',
        UNKNOWN: 'Không có dữ liệu',
        pipeline: 'Pipeline',
      },
      indexing: {
        open: 'Được lập chỉ mục',
        closed: 'Đã đóng',
        unset: 'Chưa đặt',
        hint: 'Trang đích có mở cho công cụ tìm kiếm hay không',
      },
      columns: {
        landing: 'Trang đích',
        kind: 'Loại',
        status: 'Trạng thái',
        indexing: 'Lập chỉ mục',
        traffic: 'Lượt xem · yêu cầu',
        updated: 'Cập nhật',
      },
      trafficPeriod: '7 ngày qua',
      trafficUnavailable: 'Không có thống kê',
      empty: {
        title: 'Chưa có trang đích',
        description: 'Danh mục trống hoặc đã bị lọc hết.',
      },
      card: {
        tabs: {
          overview: 'Tổng quan',
          seo: 'SEO',
        },
        address: 'Địa chỉ và truy cập',
        addressHint: 'Địa chỉ làm việc của trang đích. Không dùng tên miền phụ.',
        openPage: 'Mở trang',
        form: 'Biểu mẫu',
        formConnected: 'Đã kết nối · gửi về cùng tên miền',
        publication: 'Xuất bản',
        lastDeploy: 'Lần triển khai gần nhất',
        publishedBy: 'Người chạy',
        never: 'Chưa từng xuất bản',
        preview: 'Xem trước',
        previewHint: 'Mở trong tab mới',
        traffic: '7 ngày qua',
        views: 'Lượt xem',
        leads: 'Yêu cầu',
        notFound: 'Không tìm thấy trang đích',
      },
      anonymous: {
        title: 'Kênh ẩn danh',
        description:
          'Trang nằm trên tên miền của đối tác và được dựng bằng pipeline riêng (ADR-0022). Xuất bản và cài đặt SEO được quản lý ở kênh đó.',
      },
      actions: {
        publish: 'Xuất bản',
        unpublish: 'Gỡ xuất bản',
        open: 'Mở',
      },
      seo: {
        indexing: {
          title: 'Lập chỉ mục',
          toggle: 'Mở cho công cụ tìm kiếm',
          on: 'Bật: trang mở cho tìm kiếm — meta robots = index, follow. Trang đích nằm trên tên miền chính và không có robots.txt riêng: tệp chung của tên miền không bị thay đổi.',
          off: 'Tắt: trang vẫn truy cập được, nhưng meta robots = noindex, nofollow loại nó khỏi kết quả. Trang đích nằm trên tên miền chính và không có robots.txt riêng: tệp chung của tên miền không bị thay đổi.',
          sitemap: 'Thêm vào sitemap.xml của trang chính',
          sitemapHint:
            'Chỉ dành cho trang đã mở: trang đóng mà nằm trong sơ đồ trang là mâu thuẫn và Search Console sẽ cảnh báo.',
        },
        meta: {
          title: 'Thẻ meta',
          seoTitle: 'Tiêu đề trang (title)',
          seoDescription: 'Mô tả (description)',
          titleCounter: '{count} trên 60 ký tự — hiển thị đầy đủ trong kết quả',
          titleCounterOver: '{count} ký tự — kết quả sẽ cắt ở khoảng 60',
          descriptionCounter: '{count} trên 160 ký tự — công cụ tìm kiếm hiển thị khoảng 160',
          canonical: 'Địa chỉ chuẩn',
          canonicalSelf: 'Địa chỉ của trang — {url}',
          canonicalExternal: 'Trang khác — nhập địa chỉ',
          canonicalUrl: 'Địa chỉ trang chuẩn',
          canonicalUrlError: 'Cần địa chỉ đầy đủ dạng https://…',
          canonicalHint:
            'Nếu cùng dự án đã có trên trang chính, chỉ một trang được chọn làm chuẩn — nếu không chúng chia nhau cùng một truy vấn.',
          image: 'Ảnh cho tin nhắn và mạng xã hội',
          imageHint: '1200 × 630, JPG hoặc PNG — Telegram, WhatsApp và Facebook sẽ hiển thị',
          imageUpload: 'Tải lên',
          imageReplace: 'Thay ảnh',
          imageError: 'Không tải được ảnh',
        },
        output: {
          title: 'Nội dung sẽ lên production',
          sitemapFile: 'sitemap.xml của trang chính',
          sitemapIn: 'địa chỉ được đưa vào',
          sitemapOut: 'địa chỉ bị loại — trang đóng với tìm kiếm',
          hint: 'Thẻ được áp dụng khi xuất bản từ cài đặt ở trên — không sửa tay trong mã nguồn, nếu không cài đặt và production sẽ lệch nhau.',
        },
        preview: {
          title: 'Tìm kiếm sẽ hiển thị thế nào',
          fallbackTitle: 'Tiêu đề lấy từ mã nguồn trang',
          fallbackDescription: 'Mô tả lấy từ mã nguồn trang',
          hint: 'Công cụ tìm kiếm có thể hiển thị văn bản riêng, nhưng lấy từ các trường này.',
        },
        checks: {
          title: 'Kiểm tra',
          titleOk: 'Tiêu đề {count} ký tự — hiển thị đầy đủ',
          titleLong: 'Tiêu đề {count} ký tự — sẽ bị cắt',
          titleEmpty: 'Chưa đặt tiêu đề — nội dung trong mã nguồn sẽ lên production',
          descriptionOk: 'Mô tả {count} ký tự',
          descriptionLong: 'Mô tả {count} ký tự — công cụ tìm kiếm hiển thị khoảng 160',
          descriptionEmpty: 'Chưa đặt mô tả — nội dung trong mã nguồn sẽ lên production',
          complexCompeting: 'Cùng dự án đã mở trên trang chính: {url}. Hãy chọn trang nào là chuẩn',
          complexAction: 'Chọn trang dự án làm chuẩn',
          canonicalInvalid: 'Địa chỉ chuẩn chưa đầy đủ: cần địa chỉ https://',
          closed: 'Trang đóng với tìm kiếm — cài đặt vẫn lưu, nhưng trang sẽ không vào kết quả',
        },
        footer: 'Cài đặt được áp dụng ở lần xuất bản tiếp theo.',
        save: 'Lưu',
        cancel: 'Huỷ',
      },
      publishModal: {
        publishTitle: 'Xuất bản trang đích',
        unpublishTitle: 'Gỡ xuất bản',
        publishConfirm: 'Xuất bản',
        unpublishConfirm: 'Gỡ',
        cancel: 'Huỷ',
        willDeploy: 'Nội dung sẽ lên production',
        robots: 'Thẻ robots',
        canonical: 'Địa chỉ chuẩn',
        sitemap: 'Sơ đồ trang',
        sitemapIn: 'địa chỉ sẽ vào sitemap.xml chung',
        sitemapOut: 'địa chỉ bị loại — trang đóng với tìm kiếm',
        robotsFileNote:
          'robots.txt dùng chung cho tên miền và không thay đổi ở đây: thẻ meta quyết định lập chỉ mục.',
        closedWarning:
          'Trang đóng với tìm kiếm: vẫn truy cập được theo địa chỉ, nhưng thẻ meta loại nó khỏi kết quả.',
        seoEmptyWarning: 'Chưa đặt tiêu đề và mô tả — nội dung trong mã nguồn sẽ lên production.',
        unpublishWarning: 'Tệp sẽ bị xoá khỏi kho lưu trữ, địa chỉ bắt đầu trả về 404.',
      },
    },
  },
}
